import classnames from 'classnames';
import { map } from 'lodash/fp';
import React, { Dispatch, SetStateAction } from 'react';

import { DeviceModelType as OrgDeviceModelType } from '@portals/api/organizations';
import { DeviceModelType as PartnerDeviceModelType } from '@portals/api/partners';
import { Select } from '@portals/ui';

type Option = { label: string; value: string };

interface ModelSelectionProps<
  TDeviceModel extends OrgDeviceModelType | PartnerDeviceModelType
> {
  deviceModels: Array<TDeviceModel>;
  isLoading: boolean;
  selectedModel: Option;
  setSelectedModel: Dispatch<SetStateAction<Option>>;
  className?: string;
  height?: number;
}

export function ModelSelection<
  TDeviceModel extends OrgDeviceModelType | PartnerDeviceModelType
>({
  deviceModels,
  isLoading,
  selectedModel,
  setSelectedModel,
  className,
  height = 45,
}: ModelSelectionProps<TDeviceModel>) {
  const modelsList = map(
    ({ model, id }) => ({ label: model, value: id }),
    deviceModels
  );

  return (
    <Select
      className={classnames(className, 'model-selection-container')}
      height={height}
      isPending={isLoading}
      items={modelsList}
      selectedItem={selectedModel}
      setSelectedItem={setSelectedModel}
      defaultOptionLabel="All Models"
    />
  );
}
